import axios from 'axios';
import { getAuthTokenFromRefreshToken } from '../api/Authentication/api';

const baseURL = process.env.REACT_APP_API_BASE_URL || 'http://161.35.15.150:8000';
const axiosInstance = axios.create({
  baseURL: baseURL,
});

axiosInstance.interceptors.request.use((config) => {
  // Add the Authorization header with token from localStorage or query params
  let token =
    !window.location.pathname.includes('reset-password')
      ? localStorage.getItem('token')
      : new URLSearchParams(window.location.search)?.get('token');
  if (token) {
    config.headers['Authorization'] = 'Bearer ' + token;
  }

  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error?.response?.status === 401 && error?.response?.data?.error === "Invalid or expired token.") {
      const refreshToken = localStorage.getItem('refresh_token');
      if (refreshToken) {
        try {
          const refreshData = await getAuthTokenFromRefreshToken(refreshToken);
          const newAccessToken = refreshData.data.access;
          const newRefreshToken = refreshData.data.refresh;

          localStorage.setItem('token', newAccessToken);
          localStorage.setItem('refresh_token', newRefreshToken);
          axiosInstance.defaults.headers.common['Authorization'] = 'Bearer ' + newAccessToken;
          originalRequest.headers['Authorization'] = 'Bearer ' + newAccessToken;

          return axiosInstance(originalRequest);
        } catch (refreshError) {
          localStorage.removeItem('refresh_token');
          localStorage.removeItem('token');
          window.location.href = '/login';
        }
      } else {
        window.location.href = '/login';
      }
    }

    throw error;
  }
);

export default axiosInstance;
